const domaine = 'SNACKBAR'

export const AFFICHER_SNACKBAR = `${domaine}/AFFICHER_SNACKBAR`
export const CACHER_SNACKBAR = `${domaine}/CACHER_SNACKBAR`
